import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const getAllAdhocJobsAsync = createAsyncThunk(
  "adhocjob/getAllAdhocJobs",
  async (payload, toolkit) => {
    const finalPayload = { ...payload, platform: "website" };
    return await AxiosClient(
      "GET",
      `/adhocjob/get-all`,
      [],
      toolkit,
      finalPayload
    );
  }
);

export const updateAdhocJobAdminStatusAsync = createAsyncThunk(
  "adhocjob/updateAdminStatus",
  async ({ id, adminStatus }, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/adhocjob/update-admin-status/${id}`,
      { adminStatus },
      toolkit
    );
  }
);

export const getAdhocJobByJobIdAsync = createAsyncThunk(
  "job/ActivityViewByJobId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/adhocjob/get-single-job?adhocJobId=${payload?.jobaActivityInfoId}&page=${payload?.page || 1
      }&limit=${payload?.limit || 10}`,
      [],
      toolkit
    );
  }
);

export const getAdhocJobCostAsync = createAsyncThunk(
  "adhocjob/getAdhocJobCost",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/costreport/get-costs/${payload?.jobId}`,
      [],
      toolkit
    );
  }
);

// Dynamic module schema for the read-only cost report page — see
// docs/adhoc-cost-report-dynamic-fields-frontend-plan.md
export const getAdhocCostModuleSchemaAsync = createAsyncThunk(
  "adhocjob/getAdhocCostModuleSchema",
  async (_, toolkit) => {
    return await AxiosClient("GET", `/costreport/module-schema`, [], toolkit);
  }
);

export const updateAdhocJobTextValidationAsync = createAsyncThunk(
  "adhocjob/updateTextValidation",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/adhocjob/update-text-validation`,
      payload,
      toolkit
    );
  }
);

// Attach Main Job to Adhoc Job — see docs/adhoc-job-attach-main-job-frontend-plan.md

export const getAttachableJobsAsync = createAsyncThunk(
  "adhocjob/getAttachableJobs",
  async (adhocJobId, toolkit) => {
    return await AxiosClient(
      "GET",
      `/adhocjob/attachable-jobs`,
      [],
      toolkit,
      { adhocJobId }
    );
  }
);

export const attachMainJobAsync = createAsyncThunk(
  "adhocjob/attachMainJob",
  async ({ adhocJobId, mainJobId }, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/adhocjob/attach-main-job/${adhocJobId}`,
      { mainJobId },
      toolkit
    );
  }
);

export const detachMainJobAsync = createAsyncThunk(
  "adhocjob/detachMainJob",
  async (adhocJobId, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/adhocjob/detach-main-job/${adhocJobId}`,
      [],
      toolkit
    );
  }
);

// Fumigation Data (Container/Warehouse/Vessel) — read-only for admin, see
// docs/adhoc-fumigation-visit-flow-plan.md
export const getFumigationDataAsync = createAsyncThunk(
  "adhocjob/getFumigationData",
  async (jobId, toolkit) => {
    return await AxiosClient(
      "GET",
      `/fumigation-data/get/${jobId}`,
      [],
      toolkit
    );
  }
);